import { untilComponentDestroyed } from '@alyle/ui';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Partner } from 'src/app/shared/models/partner';
import { Show } from 'src/app/shared/models/show';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
  selector: 'app-move-show-modal',
  templateUrl: './move-show-modal.component.html',
  styleUrls: ['./move-show-modal.component.scss']
})
export class MoveShowModalComponent implements OnInit {

  partner: Partner;

  showId: number;
  show: Show;

  partnerOptions: any[] = [];

  allPartners: Partner[];

  selectedPartnerId: number;

  constructor(private partnerService: PartnerService, private snackbarService: SnackBarService, public dialogRef: MatDialogRef<MoveShowModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.showId = data.showId; // Accessing the passed show data
  }

  ngOnInit() {

    this.partnerService.getShow(this.showId).subscribe(resShow => {
      this.show = resShow;
    });

    // Track partner
    this.partnerService.selectedPartner$.subscribe((x) => {
      this.partner = x;

      // Begin process for creating available partners list
      this.partnerService.getPartners().subscribe((x) => {
        this.allPartners = x;

        // Filter out current partner
        this.partnerOptions = this.allPartners.filter(partner => partner.id !== this.partner.id)
          .map(partner => ({
            id: partner.id,
            name: partner.name,
            isSelected: false
          }));
      });
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  moveShow() {
    if (this.selectedPartnerId) {
      //pull other partner data
      this.partnerService.getPartner(this.selectedPartnerId).subscribe(resPartner => {

        //add show to partner.shows list
        resPartner.shows.push(this.show);

        //update partner
        this.partnerService.updatePartner(resPartner).subscribe(
          (response) => {
            //success, now remove the show from the current partner
            let index = this.partner.shows.findIndex(item => item.id === this.show.id);

            if (index > -1) {
              //remove the show from the selected partners shows list
              this.partner.shows = this.partner.shows.filter(item => item.id !== this.show.id);

              //now update partner
              this.partnerService.updatePartner(this.partner).subscribe(
                (res) => {
                  //update global variable
                  this.partnerService.setSelectedPartner(res);

                  this.snackbarService.showSnackBarMessage("Show successfully moved!", "Close");

                  this.onClose();
                },
                (error) => {
                  this.snackbarService.showSnackBarMessage("An error occurred saving the changes.", "Close", undefined, true);
                });
            }
            else {
              //something went wrong
              this.snackbarService.showSnackBarMessage("An error occurred and the show could not be removed from the current partner.", "Close", undefined, true);
            }

          },
          (error) => {
            //show error message, don't remove show from current partner
            this.snackbarService.showSnackBarMessage("An error occurred while moving the show.", "Close", undefined, true);
          }
        )

      })

    }
    else {
      this.snackbarService.showSnackBarMessage("You must select a partner to move the show to.", "Close", undefined, true);
    }
  }

}
